import { useEffect, useState } from 'react';
import { LightUSB } from '../libraries';
import { useAppSelector } from '../redux-store/hooks';

const usePrinterSettings = () => {
  const printerSettings = useAppSelector((state) => state.clientInfo?.data?.printerSettings);
  const [printerUsb, setPrinterUsb] = useState<LightUSB | null>(null);
  const [printerStatus, setPrinterStatus] = useState(false);
  const [loading, setLoading] = useState(false);

  const loadPrinterSettings = async (isReload = false) => {
    if (loading) return; // prevent multiple loads
    setLoading(true);
    try {
      if (printerSettings) {
        const { vendorId, productId, name } = printerSettings;
        if (vendorId && productId) {
          const printerObj = new LightUSB(Number(productId), Number(vendorId));
          const ispaired = await printerObj.isPaired();
          if (ispaired && isReload) {
            setPrinterStatus(ispaired);
          } else {
            const statusObj = await printerObj.connect();
            setPrinterStatus(statusObj.status);
          }
          setPrinterUsb(printerObj);
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const loadInitialProcess = async () => {
    await loadPrinterSettings();
  };

  useEffect(() => {
    loadInitialProcess();
  }, []);

  return { printerUsb, setPrinterUsb, printerStatus, setPrinterStatus, loadPrinterSettings };
};

export { usePrinterSettings };